import SectionHeading from "@/components/base/SectionHeading";
import WorkCard from "@/components/feature/WorkCard";
import { allWorks } from "@/lib/content";

export default function FeaturedWorks() {
  const featured = [...allWorks].sort((a, b) => b.popularity - a.popularity).slice(0, 4);

  return (
    <section className="mb-14">
      <SectionHeading
        title="代表作品精选"
        subtitle="从犯罪悬疑到科幻冒险，一览筱田优的重点主演作品"
        moreTo="/works"
        moreLabel="全部作品"
      />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {featured.map((work) => (
          <WorkCard key={work.id} work={work} />
        ))}
      </div>
    </section>
  );
}